// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberListRequestModel {
    static getAttributeTypeMap() {
        return PrescriberListRequestModel.attributeTypeMap;
    }
}
PrescriberListRequestModel.discriminator = undefined;
PrescriberListRequestModel.attributeTypeMap = [
    {
        "name": "prescriberIds",
        "baseName": "prescriberIds",
        "type": "Array<number>"
    }
];
//# sourceMappingURL=prescriberListRequestModel.js.map